module.exports = __webpack_public_path__ + "static/img/apply.cb90d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/apply.png
// module id = sR47
// module chunks = 0